import { render, staticRenderFns } from "./formBody.vue?vue&type=template&id=8fba0d76&scoped=true&"
import script from "./formBody.vue?vue&type=script&lang=js&"
export * from "./formBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fba0d76",
  null
  
)

export default component.exports